import personnummer from 'personnummer.js';
import {SettingsContext} from "@/utilities/settings-context";
import moment from 'moment';
import { validateDate } from '@noordigitalagency/accounts-ledigajobb';

export function validateDateOfBirth(dateOfBirth: string) {
  const dateIsValid = validateDate(dateOfBirth);

  if(dateIsValid){
    const minAge = SettingsContext.get('user.minAge') as number;
    const currentYear = new Date().getFullYear();
    const minYearValid = currentYear - minAge;

    const dateOfBirthYear = moment(dateOfBirth).year();

    return dateOfBirthYear <= minYearValid;
  }else
    return false;
}

export function validateCIN(cin: string): {valid: boolean; type: string; input: string; normalised: string; reason: string } {

    return personnummer.parseCIN(cin);
}

export function validateString(str: unknown): str is string {
  if(!str) {
    return false;
  }

  return typeof str === 'string' && str.trim() != '';
}

let div = document.createElement('div');

export function validateHtml(html: unknown): boolean {
  if(!html || typeof html !== 'string') {
    return false;
  }

  div = div || document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || div.innerText || '').trim() !== '';
}

export function validatePostCode(postCode: string | null, swedish = false) {
  if(swedish) {
    return validateString(postCode) && /[1-9]\d{2}\u0020?\d{2}/.test(postCode);
  }

  return validateString(postCode);
}

export function validateUrl(str: string): boolean {
  if(!str) {
    return false;
  }

  const parts = str.split('.').filter(part => part.length >= 1);

  return parts.length >= 2 && parts[1].length >= 2;
}
